const inViewport = {
  isInViewport(el) {
    const bounding = el.getBoundingClientRect();
    const offset = window.innerWidth > 1200 ? 300 : 0;

    return (
      bounding.top >= -offset &&
      bounding.left >= 0 &&
      bounding.bottom - offset <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth)
    );
  },
};

export default inViewport;
